/*
 * Date: 2023
 * Description: Expense pages
 * Author: Philippe Leroux @ skitsc
 */

import { Box } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_initial_props } from "../interfaces/utility.interface"

const Expense = ( props : i_initial_props ) : ReactElement => {
    return (
        <Box>

        </Box>
    )
}


export default Expense